import React from 'react';
import './SidebarMenuItem.css';

const SidebarMenuItem = ({ children, icon, onClick, className = '' }) => {
    return (
        <div 
            className={`sidebar-menu-item ${className}`}
            onClick={onClick}
        >
            {icon && <span className="sidebar-menu-item-icon">{icon}</span>}
            <span className="sidebar-menu-item-text">{children}</span>
        </div>
    );
};

export default SidebarMenuItem;
